module.exports = __webpack_public_path__ + "img/file_upload_takeNotes.aecf32ce.svg";